









































































import ForgotPasswordMutation from '@/graphql/mutations/forgotPassword.gql';
import LoginMutation from '@/graphql/mutations/login.gql';
import request from '@/graphql/request';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class Login extends Vue {
  @Prop() public showClass!: string;
  @Prop() public showText!: string;
  @Prop() public enableLogout!: string;
  @Prop() public alternateLink!: string;
  @Prop() public alternateText!: string;

  public email: string = '';
  public password: string = '';
  public isActive = false;
  public errorMessage: string = '';
  public showLogout = false;
  public isResetting: boolean = false;
  public resetInProgress: boolean = false;
  public resetMessage: string = '';

  public submit() {
    this.errorMessage = '';
    this.resetMessage = '';
    this.isResetting ? this.resetPassword() : this.login();
  }

  public logout() {
    this.$store.dispatch('auth/deleteAuthToken');
    this.close();
    this.$router.push('/');
  }

  public close() {
    this.isActive = false;
  }

  public show() {
    this.isActive = true;
    this.errorMessage = '';
    this.email = '';
    this.password = '';
  }

  get submitClass() {
    return {
      dim: this.email && this.password,
    };
  }

  private login() {
    const email = this.email;
    const password = this.password;

    request(LoginMutation as any, { email, password })
      .then(({ data }) => {
        const token = data && data.beginSession.sessionToken;
        if (token) {
          this.$store.dispatch('auth/setAuthToken', token);
          this.close();
        } else {
          this.errorMessage =
            'Email or password was entered incorrectly. Please try again later.';
        }
      })
      .catch(error => {
        this.errorMessage = 'Please try again later.';
      });
  }

  private resetPassword() {
    const email = this.email;

    this.resetInProgress = true;

    request(ForgotPasswordMutation as any, { email })
      .then(({ errors }: any) => {
        console.log(errors);
        if (errors && errors.length) {
          throw errors;
        }
        this.resetMessage = 'Password was reset. Please check your email.';
        this.isResetting = false;
        this.resetInProgress = false;
      })
      .catch(error => {
        this.resetInProgress = false;
        this.errorMessage = 'The email entered was not found.';
      });
  }
}
